var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _g, _path1, _path10, _g2, _path11, _path12, _g3, _g4, _path13, _path14, _path15, _path16, _g5, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTriivacoLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 201,
    height: 45,
    viewBox: "0 0 201 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M187.951 40.22C185.563 40.22 183.369 39.6595 181.371 38.5386C179.373 37.4176 177.789 35.8702 176.619 33.8964C175.45 31.8982 174.865 29.6441 174.865 27.1342C174.865 24.6486 175.45 22.4189 176.619 20.445C177.789 18.4468 179.373 16.8873 181.371 15.7663C183.369 14.6454 185.563 14.0849 187.951 14.0849C190.363 14.0849 192.556 14.6454 194.53 15.7663C196.528 16.8873 198.1 18.4468 199.245 20.445C200.415 22.4189 201 24.6486 201 27.1342C201 29.6441 200.415 31.8982 199.245 33.8964C198.1 35.8702 196.528 37.4176 194.53 38.5386C192.532 39.6595 190.339 40.22 187.951 40.22ZM187.951 35.6509C189.486 35.6509 190.838 35.3098 192.008 34.6275C193.178 33.9208 194.092 32.9217 194.749 31.6301C195.407 30.3386 195.736 28.84 195.736 27.1342C195.736 25.4284 195.407 23.9419 194.749 22.6748C194.092 21.3832 193.178 20.3963 192.008 19.714C190.838 19.0317 189.486 18.6905 187.951 18.6905C186.415 18.6905 185.051 19.0317 183.857 19.714C182.687 20.3963 181.773 21.3832 181.115 22.6748C180.457 23.9419 180.128 25.4284 180.128 27.1342C180.128 28.84 180.457 30.3386 181.115 31.6301C181.773 32.9217 182.687 33.9208 183.857 34.6275C185.051 35.3098 186.415 35.6509 187.951 35.6509Z",
    fill: "#062350"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M146.808 27.1708C146.808 24.6609 147.368 22.419 148.489 20.4451C149.635 18.4469 151.182 16.8995 153.131 15.8029C155.105 14.682 157.311 14.1215 159.747 14.1215C162.599 14.1215 165.096 14.8526 167.241 16.3147C169.385 17.7768 170.884 19.7994 171.737 22.3824H165.852C165.267 21.164 164.438 20.2502 163.366 19.641C162.318 19.0318 161.1 18.7271 159.711 18.7271C158.224 18.7271 156.896 19.0805 155.727 19.7872C154.581 20.4695 153.68 21.4442 153.022 22.7114C152.388 23.9785 152.071 25.465 152.071 27.1708C152.071 28.8522 152.388 30.3387 153.022 31.6302C153.68 32.8974 154.581 33.8843 155.727 34.591C156.896 35.2733 158.224 35.6144 159.711 35.6144C161.1 35.6144 162.318 35.3098 163.366 34.7006C164.438 34.067 165.267 33.1411 165.852 31.9226H171.737C170.884 34.53 169.385 36.5648 167.241 38.0269C165.121 39.4646 162.623 40.1835 159.747 40.1835C157.311 40.1835 155.105 39.6352 153.131 38.5386C151.182 37.4177 149.635 35.8703 148.489 33.8965C147.368 31.9226 146.808 29.6807 146.808 27.1708Z",
    fill: "#062350"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M144.983 14.4504L135.625 39.9641H129.411L120.054 14.4504H125.537L132.555 34.7371L139.536 14.4504H144.983Z",
    fill: "#062350"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M117.008 14.4504V39.9641H111.891V14.4504H117.008Z",
    fill: "#062350"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M106.835 14.4504V39.9641H101.717V14.4504H106.835Z",
    fill: "#062350"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M91.4598 39.9641L85.8307 30.0218H83.4183V39.9641H78.3009V14.4504H87.8777C89.8515 14.4504 91.5329 14.8038 92.9219 15.5105C94.3109 16.1928 95.3466 17.131 96.0289 18.325C96.7356 19.4947 97.0889 20.8106 97.0889 22.2727C97.0889 23.9541 96.6016 25.4771 95.6268 26.8418C94.6521 28.182 93.2022 29.108 91.2771 29.6198L97.3814 39.9641H91.4598ZM83.4183 26.1838H87.6949C89.0839 26.1838 90.1196 25.8548 90.8019 25.1969C91.4842 24.5146 91.8254 23.5764 91.8254 22.3823C91.8254 21.2127 91.4842 20.311 90.8019 19.6775C90.1196 19.0195 89.0839 18.6905 87.6949 18.6905H83.4183V26.1838Z",
    fill: "#062350"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M74.5671 14.4504V18.5809H67.7683V39.9641H62.651V18.5809H55.8522V14.4504H74.5671Z",
    fill: "#062350"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_292_496",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 52,
    height: 45
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M0.466614 39.7432C-0.854372 42.0177 0.786539 44.8683 3.4167 44.8683H47.6105C50.2407 44.8683 51.8816 42.0177 50.5606 39.7432L28.4637 1.69814C27.1486 -0.566047 23.8786 -0.566047 22.5635 1.69814L0.466614 39.7432Z",
    fill: "#011636"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_292_496)"
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M36.7231 18.1849L37.576 17.2101H39.2818L54.2683 40.6038V45.1119H25.27V43.1625L25.7573 39.1417L27.3413 29.1507L34.1644 20.9872L36.7231 18.1849Z",
    fill: "url(#paint0_linear_292_496)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_292_496",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 25,
    y: 17,
    width: 30,
    height: 29
  }, _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M36.7231 18.1849L37.576 17.2101H39.2818L54.2683 40.6038V45.1119H25.27V43.1625L25.7573 39.1417L27.3413 29.1507L34.1644 20.9872L36.7231 18.1849Z",
    fill: "url(#paint1_linear_292_496)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_292_496)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    filter: "url(#filter0_f_292_496)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 51.1004,
    cy: 32.1967,
    rx: 10.7221,
    ry: 10.7221,
    fill: "#7EFF81"
  })))), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M25.2699 43.2843V45.3556L20.8836 46.3303L-3.11928 47.1832L-3.4848 40.9693L8.45571 21.2309L12.9639 16.7227L13.8168 17.4538L17.9594 21.9619L23.5641 29.2724L25.0262 37.4359L25.2699 43.2843Z",
    fill: "url(#paint2_linear_292_496)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_292_496",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: -4,
    y: 16,
    width: 30,
    height: 32
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M25.2699 43.2843V45.3556L20.8836 46.3303L-3.11928 47.1832L-3.4848 40.9693L8.45571 21.2309L12.9639 16.7227L13.8168 17.4538L17.9594 21.9619L23.5641 29.2724L25.0262 37.4359L25.2699 43.2843Z",
    fill: "url(#paint3_linear_292_496)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_292_496)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    filter: "url(#filter1_f_292_496)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 1.99812,
    cy: 33.2932,
    r: 12.306,
    fill: "#FBB45E"
  })))), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M35.0173 20.1343L37.6978 17.0882L38.5507 16.3572L37.9415 13.0675L28.8034 -4.47778L23.0768 -3.38121L11.7455 15.0169L13.4513 17.2101L14.0605 17.9411L19.9089 24.3988L25.1481 28.5414L29.4126 26.2264L35.0173 20.1343Z",
    fill: "url(#paint4_linear_292_496)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_292_496",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 11,
    y: -5,
    width: 28,
    height: 34
  }, _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M35.0173 20.1343L37.6978 17.0882L38.5507 16.3572L37.9415 13.0675L28.8034 -4.47778L23.0768 -3.38121L11.7455 15.0169L13.4513 17.2101L14.0605 17.9411L19.9089 24.3988L25.1481 28.5414L29.4126 26.2264L35.0173 20.1343Z",
    fill: "url(#paint5_linear_292_496)"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_292_496)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    filter: "url(#filter2_f_292_496)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 24.6607,
    cy: 2.34534,
    r: 12.306,
    fill: "#D2FB5E"
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8,
    filter: "url(#filter3_f_292_496)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.89 21.9234C29.5584 21.9234 30.9109 20.5682 30.9109 18.8966C30.9109 17.225 29.5584 15.8699 27.89 15.8699C26.2216 15.8699 24.8691 17.225 24.8691 18.8966C24.8691 20.5682 26.2216 21.9234 27.89 21.9234Z",
    fill: "#361E79"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.7662 17.0806L25.4666 24.3052C26.8836 25.3606 28.8215 25.3682 30.2468 24.3241L40.1346 17.0806C36.3485 22.2462 30.065 33.1425 27.6886 45.3302C25.715 33.6268 20.1566 23.0533 15.7662 17.0806Z",
    fill: "#361E79"
  }))), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M25.4532 21.9234C27.1216 21.9234 28.4741 20.5682 28.4741 18.8966C28.4741 17.225 27.1216 15.8699 25.4532 15.8699C23.7848 15.8699 22.4323 17.225 22.4323 18.8966C22.4323 20.5682 23.7848 21.9234 25.4532 21.9234Z",
    fill: "url(#paint6_linear_292_496)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3294 17.0806L23.0298 24.3052C24.4468 25.3606 26.3847 25.3682 27.8099 24.3241L37.6978 17.0806C33.9116 22.2462 27.6282 33.1425 25.2518 45.3302C23.2782 33.6268 17.7197 23.0533 13.3294 17.0806Z",
    fill: "url(#paint7_linear_292_496)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask4_292_496",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 13,
    y: 15,
    width: 25,
    height: 31
  }, _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M25.4532 21.9234C27.1216 21.9234 28.4741 20.5682 28.4741 18.8966C28.4741 17.225 27.1216 15.8699 25.4532 15.8699C23.7848 15.8699 22.4323 17.225 22.4323 18.8966C22.4323 20.5682 23.7848 21.9234 25.4532 21.9234Z",
    fill: "url(#paint8_linear_292_496)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3294 17.0806L23.0298 24.3052C24.4468 25.3606 26.3847 25.3682 27.8099 24.3241L37.6978 17.0806C33.9116 22.2462 27.6282 33.1425 25.2518 45.3302C23.2782 33.6268 17.7197 23.0533 13.3294 17.0806Z",
    fill: "url(#paint9_linear_292_496)"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_292_496)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M21.7365 27.323C27.8286 28.4196 33.5552 24.5206 36.1139 20.1343L32.0931 45.5993C31.6057 45.9242 29.6075 46.3791 25.5136 45.5993C26.2447 40.2383 25.1481 32.5622 21.7365 27.323Z",
    fill: "#3EB0A0"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_f_292_496)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 22.5894,
    cy: 24.3988,
    rx: 8.77262,
    ry: 8.77262,
    fill: "white"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_292_496",
    x: -4.6217,
    y: -23.5254,
    width: 111.444,
    height: 111.444,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 22.5,
    result: "effect1_foregroundBlur_292_496"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_292_496",
    x: -55.3079,
    y: -24.0128,
    width: 114.612,
    height: 114.612,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 22.5,
    result: "effect1_foregroundBlur_292_496"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f_292_496",
    x: -32.6454,
    y: -54.9607,
    width: 114.612,
    height: 114.612,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 22.5,
    result: "effect1_foregroundBlur_292_496"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_f_292_496",
    x: -9.23376,
    y: -9.13013,
    width: 74.3684,
    height: 79.4603,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12.5,
    result: "effect1_foregroundBlur_292_496"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_f_292_496",
    x: -31.1832,
    y: -29.3738,
    width: 107.545,
    height: 107.545,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 22.5,
    result: "effect1_foregroundBlur_292_496"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_292_496",
    x1: 46.5923,
    y1: 33.2933,
    x2: 28.316,
    y2: 40.7256,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6FE49B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0F7CA8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_292_496",
    x1: 46.5923,
    y1: 33.2933,
    x2: 28.316,
    y2: 40.7256,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6FE49B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0F7CA8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_292_496",
    x1: 25.2699,
    y1: 31.953,
    x2: 2.68071,
    y2: 38.1104,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#260BCC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BF53FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_292_496",
    x1: 25.2699,
    y1: 31.953,
    x2: 2.68071,
    y2: 38.1104,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#260BCC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BF53FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_292_496",
    x1: 26.2447,
    y1: -0.335157,
    x2: 20.9322,
    y2: 24.5701,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCA6D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E64711"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_292_496",
    x1: 26.2447,
    y1: -0.335157,
    x2: 20.9322,
    y2: 24.5701,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCA6D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E64711"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_292_496",
    x1: 21.6147,
    y1: 22.9367,
    x2: 30.8746,
    y2: 37.0704,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C5F0E3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_292_496",
    x1: 21.6147,
    y1: 22.9367,
    x2: 30.8746,
    y2: 37.0704,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C5F0E3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_292_496",
    x1: 21.6147,
    y1: 22.9367,
    x2: 30.8746,
    y2: 37.0704,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#229975"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_292_496",
    x1: 21.6147,
    y1: 22.9367,
    x2: 30.8746,
    y2: 37.0704,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#229975"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTriivacoLogo);
export default __webpack_public_path__ + "static/media/triivaco_logo.a1a0ee82ab17e6b87c2781cfe27f349e.svg";
export { ForwardRef as ReactComponent };